import React from "react";
import { useQuickSightDevopsAgent } from "@/hooks/useDevopsAgentReports";

const QuickSightAwsDevopsAgentDashboard = () => {
  const { embedUrl } = useQuickSightDevopsAgent ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsDevopsAgentDashboard;
